export const SECURITYROLES = 'md_security_roles_GLOBAL';